import type { ReactNode } from 'react';

import { FailedToLoad } from '@cast/shared-messages-ui';

import { Box } from '@cast/design-system';

type DashboardSectionErrorProps = {
  hasError?: boolean;
  onRetry?: () => void;
  children: ReactNode;
};

export const DashboardSectionError = ({
  hasError,
  onRetry,
  children,
}: DashboardSectionErrorProps) => {
  if (hasError) {
    return (
      <Box py={24}>
        <FailedToLoad
          title="Failed to load metrics"
          refresh={onRetry}
          compact
        />
      </Box>
    );
  }

  return <>{children}</>;
};
